// Área PERFIS (acessos — dados sensíveis).
// warnbox (no HTML), busca, células editáveis, botões de copiar e add/del.
import { buildTable } from './shared.js'
import { state, posicaoTopo } from '../store.js'
import { perfisRepo, perfilValorColuna, PERFIL_COL } from '../data/repositories.js'

let perfisSearch = ''

let toast = () => {}
export function setToast(fn) {
  toast = fn
}

async function persistir(p, campo) {
  if (!p.id) return
  try {
    await perfisRepo.update(p.id, { [PERFIL_COL[campo]]: perfilValorColuna(campo, p[campo]) })
  } catch (e) {
    toast('Erro ao salvar', true)
  }
}

// Propaga o erro para a buildTable fazer o rollback da exclusão.
async function remover(p) {
  if (p.id) await perfisRepo.remove(p.id)
}

export function renderPerfis() {
  buildTable({
    data: state.perfis,
    bodyId: 'perfisBody',
    countId: 'perfisCount',
    search: perfisSearch,
    searchFields: [
      'data',
      'squad',
      'gestor',
      'login_fb',
      'email',
      'senha_fb',
      'senha_email',
      'fa_2',
      'conta_recuperacao',
      'links'
    ],
    cols: [
      { field: 'data', mask: 'date' },
      { field: 'squad', cls: 'wide' },
      { field: 'gestor', cls: 'wide' },
      { field: 'login_fb', cls: 'mono' },
      { field: 'email', cls: 'mono', copy: 1 },
      { field: 'senha_fb', cls: 'mono', copy: 1 },
      { field: 'senha_email', cls: 'mono', copy: 1 },
      { field: 'fa_2', cls: 'mono', copy: 1 },
      { field: 'conta_recuperacao', cls: 'mono' },
      { field: 'links', cls: 'mono' }
    ],
    onPersist: persistir,
    onDelete: remover,
    rerender: renderPerfis
  })
}

export function ligarPerfis() {
  document.getElementById('perfisSearch').oninput = e => {
    perfisSearch = e.target.value
    renderPerfis()
  }
  document.getElementById('addPerfil').onclick = async () => {
    const novo = {
      id: crypto.randomUUID(),
      data: '',
      squad: '',
      gestor: '',
      login_fb: '',
      email: '',
      senha_fb: '',
      senha_email: '',
      fa_2: '',
      conta_recuperacao: '',
      links: '',
      posicao: posicaoTopo(state.perfis)
    }
    state.perfis.unshift(novo)
    renderPerfis()
    try {
      const salvo = await perfisRepo.insert(novo)
      novo.id = salvo.id
      toast('Perfil adicionado')
    } catch (e) {
      const i = state.perfis.indexOf(novo) // rollback: insert falhou
      if (i !== -1) state.perfis.splice(i, 1)
      renderPerfis()
      toast('Erro ao salvar — perfil não criado', true)
    }
  }
}

export function onExternalChange() {
  renderPerfis()
}
